import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./styles/auth.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { ThemeProvider } from "./context/ThemeContext";
import { BrandProvider } from "./pages/student/_brand";
import SchoolProvider from "./context/SchoolProvider";   // ✅ new import

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrandProvider>
        <SchoolProvider>         {/* ✅ provides school name/logo everywhere */}
          <App />
        </SchoolProvider>
      </BrandProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
